module.exports = __webpack_public_path__ + "static/media/fzj80-landcruiser-2.f43ad935.webp";